import { useState } from 'react';
import { Table } from '../../Components/table.jsx';

export default function RequestModelPage({ requests }) {

    const [showMessagesPopup, setShowMessagesPopup] = useState(null);

    const ModelActions = (_, { model, user_messages: messages }) => (
        <div className="flex gap-2">
            <button 
                className="text-sm font-medium text-sky-600 hover:text-sky-500" 
                onClick={() => setShowMessagesPopup({model: model.label, messages})}
            >
                View Messages
            </button>
        </div>
    );

    // Define columns for the requests table
    const columns = [
        { key: 'model.label', label: 'Model', sortable: true, width: 'w-1/6', repr: (_, row) => row.model.label },
        { key: 'model.modalities', label: 'Modalities', sortable: false, hideable: true, defaultVisible: true, width: 'w-1/12', repr: (_, row) => row.model.modalities.map(m => m.toUpperCase()).join(', ') },
        { key: 'user_count', label: 'User Count', sortable: true, hideable: true, defaultVisible: true, width: 'w-1/12' },
        { key: 'usage_estimate', label: 'Usage Estimate', hideable: true, sortable: true, width: 'w-1/6', repr: (_, row) => row.user_messages.reduce((acc, msg) => acc + (msg.usage_estimate || 0), 0)  },
        { key: 'actions', label: 'Actions', sortable: false, width: 'w-1/12', display: ModelActions },
    ];

    return (
        <div className="flex flex-col items-center justify-center flex-grow gap-4">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                Model Requests
            </h1>

            <Table
                name="modelRequests"
                columns={columns}
                rows={requests}
            />

            { /* Popup for showing messages */ }
            {showMessagesPopup && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
                        <h2 className="text-lg font-semibold mb-4">Messages for {showMessagesPopup.model}</h2>
                        <ul className="space-y-2">
                            {showMessagesPopup.messages.map((msg, index) => (
                                <li key={index} className="p-2 bg-gray-100 rounded">
                                    <p className="text-sm text-gray-700">{msg.usage_estimate}</p>
                                    <p className="text-sm text-gray-700">{msg.message}</p>
                                </li>
                            ))}
                        </ul>
                        <button
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            onClick={() => setShowMessagesPopup(null)}
                        >
                            Close
                        </button>   
                    </div>
                </div>
            )}
        </div>
    )
}
